import styled from "styled-components";

export const ConsoleSmartInstallmentTableContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;

  [data-field="id"] {
    width: min-content !important;
    min-width: 70px !important;
  }

  @media (max-width: 650px) {
    .MuiDataGrid-row {
      width: 100% !important;
    }

    [data-field="id"],
    [data-field="remaining_count"],
    [data-field="purchase_date"],
    [data-field="total_installments"] {
      display: none !important;
    }
  }
`;
